'use strict';

export class P2PCampaignGallery {
    #paginationContainer;
    #imagesContainer;
    #imagesLength;
    #nextButton;
    #prevButton;
    #mainImage;
    #is_autoscroll;
    #autoscroll_image_index;
    #autoscroll_interval;
    #is_paused;

    constructor() {
        this.#paginationContainer = document.querySelector(
            '.p2p-preview-image-arrows'
        );
        this.#imagesContainer = document.querySelector(
            '.p2p-campaign-gallery-container'
        );
        this.#mainImage = document.querySelector(
            '#p2p-preview-image'
        );
        if(this.#paginationContainer) {
            this.#nextButton = this.#paginationContainer.querySelector('.p2p-preview-image-arrow-next');
            this.#prevButton = this.#paginationContainer.querySelector('.p2p-preview-image-arrow-prev');
        }
        if(this.#imagesContainer) {
            this.#imagesLength = this.#imagesContainer.children.length;
            this.#is_autoscroll = this.#imagesContainer.getAttribute('data-autoscroll');
            this.#autoscroll_image_index = 1;
        }

        this.addEvents();
    }

    addEvents() {
        if ( ! this.#paginationContainer) {
            return;
        }

        this.disableButtons();

        this.#nextButton.addEventListener('click', (event) => {
            this.#is_paused = true;
            this.#autoscroll_image_index += 1;
            let nextImageIndex = this.#nextButton.getAttribute('data-value');
            nextImageIndex = +nextImageIndex;
            this.changeMainImage(nextImageIndex);
            setTimeout(()=>{
                this.#is_paused = false;
            }, 5000);
        });

        this.#prevButton.addEventListener('click', (event) => {
            this.#is_paused = true;
            this.#autoscroll_image_index -= 1;
            let prevImageIndex = this.#prevButton.getAttribute('data-value');
            prevImageIndex = +prevImageIndex;
            this.changeMainImage(prevImageIndex);
            setTimeout(()=>{
                this.#is_paused = false;
            }, 5000);
        });

        if(this.#is_autoscroll){
            this.autoscrollCarousel();
        }

    }

    autoscrollCarousel()
    {
        if ( !this.#is_autoscroll) {
            return;
        }
        this.#autoscroll_interval = setInterval(()=>{
            if(!this.#is_paused){
                if(this.#autoscroll_image_index > this.#imagesLength){
                    this.#autoscroll_image_index = 0;
                }
                this.changeMainImage(this.#autoscroll_image_index);
                this.#autoscroll_image_index += 1;
            }
        }, 2000);
    }

    disableButtons() {
        let prevImageIndex = this.#prevButton.getAttribute('data-value');
        let nextImageIndex = this.#nextButton.getAttribute('data-value');

        if(prevImageIndex < 0){
            this.#prevButton.setAttribute('disabled', 'true');
        }else{
            this.#prevButton.removeAttribute('disabled');
        }


        if(nextImageIndex == this.#imagesLength){
            this.#nextButton.setAttribute('disabled', 'true');
        }else{
            this.#nextButton.removeAttribute('disabled');
        }
    }


    changeMainImage(index){
        if ( ! this.#mainImage || !this.#imagesContainer) {
            return;
        }

        let images = this.#imagesContainer.children;
        let selectedImage = images[index];
        if(selectedImage){
            let nextImageIndex = index + 1;
            this.#nextButton.setAttribute('data-value', nextImageIndex);
            let prevImageIndex = index - 1;
            this.#prevButton.setAttribute('data-value', prevImageIndex);
            let url = selectedImage.getAttribute('src');
            this.#mainImage.style.opacity = '0';
            setTimeout(()=>{
                this.#mainImage.setAttribute('src', url);
                this.#mainImage.style.backgroundImage = `url(${url})`;
            }, 250);
            setTimeout(()=>{
                this.#mainImage.style.opacity = '';
            }, 300);
            this.disableButtons();
        }
    }
}